export const locationConfig = {
  served: {
    field: 'service_coverage',
    unique: {
      Served: { label: 'Served', fillColor: [255, 255, 255, 1] },
    },
    size: 4,
    strokeColor: [64, 0, 0, 1],
    restricted: true,
  },
  underserved: {
    field: 'service_coverage',
    unique: {
      Underserved: { label: 'Underserved', fillColor: [225, 160, 160, 1] },
      Unserved: { label: 'Unserved', fillColor: [225, 30, 30, 1] },
    },
    size: 4,
    strokeColor: [64, 0, 0, 1],
    restricted: false,
  },
};
